
export const profile = {
    username: '用户名',
    enterUsername: '请输入您的用户名',
    characters: '个字符',
    noChangesDetected: '未检测到更改',
    profileUpdatedSuccessfully: '个人资料更新成功！',
    updateFailed: '更新失败，请重试',
    updating: '更新中...',
    saveChanges: '保存更改'
  };
